// example reference - https://www.codingandclimbing.co.uk/blog/ionic-2-camera-permissions-example-for-ios-and-android

import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { Diagnostic } from '@ionic-native/diagnostic';
import * as _ from 'lodash';

@Injectable()
export class PermissionsService {

    constructor(
        public _platform: Platform,
        public _Diagnostic: Diagnostic
    ) {}
    defaultPermissionRole = 0;

    permissionRolesMap = {
        'Material Test - Personnel': 1,
        'Material Test - Technician': 2,
        'Lab Supervisor Materials': 3,
        'Material Test - Supervisor': 3
    }


    isAndroid() {
        return this._platform.is('android')
    }

    isiOS() {
        return this._platform.is('ios');
    }

    isUndefined(type) {
        return typeof type === "undefined";
    }
    checkRolePermission(): number {
        let sessionData: any = window.localStorage.getItem('sessionData');
        if (typeof sessionData !== 'string') {
            console.log('Missing Session Data')
            return this.defaultPermissionRole;
        }
        sessionData = JSON.parse(sessionData);

        const primaryUserRole = parseInt(sessionData.UserRoleIndex) || this.defaultPermissionRole;
        let highestRole = primaryUserRole;

        if (!Array.isArray(sessionData.UserRoles) || sessionData.UserRoles.length === 0) {
            return highestRole;
        }
        const roles = sessionData.UserRoles;
        _.each(roles, (role) => {
            // if one of the roles is in the map...
            if (role.Name && this.permissionRolesMap[role.Name]) {
                // and that role is higher than the default...
                if (this.permissionRolesMap[role.Name] > highestRole) {
                    // override the default
                    highestRole = this.permissionRolesMap[role.Name];
                }
            }
        });

        return highestRole;
    }
    checkCameraPermissions(): Promise<string> {
        console.log('check camera permissions');
        return new Promise(resolve => {
            if (this.isiOS()) {
                console.log('camera platform - iOS');
                this._Diagnostic.getCameraAuthorizationStatus().then(status => {
                    if (status == this._Diagnostic.permissionStatus.GRANTED) {
                        console.log('camera - check - ios - allowed');
                        resolve('allowed');
                    }
                    else if (status == this._Diagnostic.permissionStatus.DENIED) {
                        console.log('camera - check - ios - denied');
                        resolve('denied');
                    }
                    else if (status == this._Diagnostic.permissionStatus.NOT_REQUESTED || status.toLowerCase() == 'not_determined') {
                        console.log('camera - check-  ios - undetermined');
                        resolve('undetermined');
                    }
                });
            }
            else if (this.isAndroid()) {
                console.log('camera platform - Android');
                this._Diagnostic.isCameraAuthorized().then(authorised => {
                    if (authorised) {
                        console.log('camera - check - android - allowed');
                        resolve('allowed');
                    }
                    else {
                        console.log('camera - check - android - denied');
                        resolve('denied');
                    }
                });
            } else {
                console.log('camera - check - browser?');
            }
        });
    }

    requestCameraPermission(): Promise<string> {
        console.log('request camera permissions');
        return new Promise(resolve => {
            this._Diagnostic.requestCameraAuthorization()
                .then(status => {
                    console.log('camera platform iOS status:', status);
                    if (status === 'allowed') {
                        console.log('camera - request - allowed');
                        resolve('allowed');
                    } else {
                        console.log('camera - request - denied');
                        resolve('denied');
                    }
                });
        });
    }

    checkLocationPermissions(): Promise<string> {
        console.log('check location permissions');
        return new Promise(resolve => {
            if (this.isiOS()) {
                console.log('location platform - iOS');
                this._Diagnostic.getLocationAuthorizationStatus()
                    .then(status => {
                        switch(status) {
                            case this._Diagnostic.permissionStatus.NOT_REQUESTED:
                                console.log('location - check - ios - undetermined');
                                resolve('undetermined');
                            case this._Diagnostic.permissionStatus.DENIED:
                                console.log('location - check - ios - denied');
                                resolve('denied');
                            case this._Diagnostic.permissionStatus.GRANTED:
                                console.log('location - check - ios - allowed');
                                resolve('allowed');
                            case this._Diagnostic.permissionStatus.GRANTED_WHEN_IN_USE:
                                console.log('location - check - ios - when_in_use');
                                resolve('when_in_use');
                        }
                    });
            } else if (this.isAndroid()) {
                console.log('location platform - Android');
                this._Diagnostic.getLocationAuthorizationStatus()
                    .then(status => {
                        switch(status) {
                            case this._Diagnostic.permissionStatus.NOT_REQUESTED:
                                console.log('location - check - android - undetermined');
                                resolve('undetermined');
                            case this._Diagnostic.permissionStatus.GRANTED:
                                console.log('location - check - android - allowed');
                                resolve('allowed');
                            case this._Diagnostic.permissionStatus.DENIED:
                                console.log('location - check - android - denied');
                                resolve('denied');
                            case this._Diagnostic.permissionStatus.DENIED_ALWAYS:
                                console.log('location - check - android - denied');
                                resolve('denied');
                        }
                    });
            } else {
                console.log('location - check - browser?');
            }
        });
    }

    requestLocationPermission(): Promise<string> {
        console.log('request location permissions');
        return new Promise(resolve => {
            if (this.isiOS()) {
                console.log('location platform - iOS');
                this._Diagnostic.requestLocationAuthorization()
                    .then(status => {
                        switch(status) {
                            case this._Diagnostic.permissionStatus.NOT_REQUESTED:
                                console.log('location - request - ios - undetermined');
                                resolve('undetermined');
                            case this._Diagnostic.permissionStatus.DENIED:
                                console.log('location - request - ios - denied');
                                resolve('denied');
                            case this._Diagnostic.permissionStatus.GRANTED:
                                console.log('location - request - ios - allowed');
                                resolve('allowed');
                            case this._Diagnostic.permissionStatus.GRANTED_WHEN_IN_USE:
                                console.log('location - request - ios - when_in_use');
                                resolve('when_in_use');
                        }
                    });
            }
            else if (this.isAndroid()) {
                console.log('location platform - Android');
                this._Diagnostic.requestLocationAuthorization()
                    .then(status => {
                        switch(status) {
                            case this._Diagnostic.permissionStatus.NOT_REQUESTED:
                                console.log('location - request - android - undetermined');
                                resolve('undetermined');
                            case this._Diagnostic.permissionStatus.DENIED:
                                console.log('location - request - android - denied');
                                resolve('denied');
                            case this._Diagnostic.permissionStatus.GRANTED:
                                console.log('location - request - android - allowed');
                                resolve('allowed');
                            case this._Diagnostic.permissionStatus.DENIED_ALWAYS:
                                console.log('location - request - android - denied');
                                resolve('denied');
                        }
                    });
            } else {
                console.log('location - request - browser?');
            }
        });
    }

    goToAppPermissionSettings(): Promise<boolean> {
        console.log('request app settings');
        return new Promise(resolve => {
            this._Diagnostic.switchToSettings()
                .then(status => {
                    console.log('Successfully switched to Settings app', status);
                });
        });
    }

}



// WEBPACK FOOTER //
// ./src/providers/permissions-service/permissions-service.ts